import { render, staticRenderFns } from "./SelectorColorChips.vue?vue&type=template&id=4b1189aa"
import script from "./SelectorColorChips.vue?vue&type=script&lang=js"
export * from "./SelectorColorChips.vue?vue&type=script&lang=js"
import style0 from "./SelectorColorChips.vue?vue&type=style&index=0&id=4b1189aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports